import gql from 'graphql-tag';
import FieldsBuilding from "graphql/fields/FieldsBuilding";

export default gql(`
	query buildings( $scanInAtDate: String ) {
		buildings {
			${FieldsBuilding}
			
			scans( scanned_in_at: $scanInAtDate ) {
				guid
				code
				scanned_in_at
				scanned_in_through
				
				timeslot{
					guid
					kind
					sub_kind
					timeslot_start
					timeslot_end
					capacity
				}
			}
		}
	}
`);

